import { ChangeEvent, memo, useCallback, useMemo } from 'react';

import { FormItem } from 'bloko/blocks/form';
import Radio from 'bloko/blocks/radio';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';
import TreeCollection from 'bloko/common/tree/treeCollection';
import { AdditionalDefault } from 'bloko/common/tree/types';

import translation from 'src/components/translation';

import RegionItemLabel from 'src/components/Price/RegionSelectorPopup/RegionItemLabel';

export interface RegionsListAdditional extends AdditionalDefault {
    visible: boolean;
}

interface RegionsListProps {
    collection: TreeCollection<RegionsListAdditional>;
    selectedId: string | null;
    showTitle: boolean;
    onChange: (id: string) => void;
}

const TrlKeys = {
    regionInPackage: 'employer.price.resume-access.regionInPackage',
};

const RegionsList: TranslatedComponent<RegionsListProps> = ({ collection, selectedId, showTitle, onChange, trls }) => {
    const regionsList = useMemo(() => collection.toList(), [collection]);

    const handleChange = useCallback(
        (event: ChangeEvent<HTMLInputElement>) => {
            onChange(event.target.value);
        },
        [onChange]
    );

    if (regionsList.length === 0) {
        return null;
    }

    return (
        <>
            {showTitle && <FormItem>{trls[TrlKeys.regionInPackage]}</FormItem>}
            {regionsList.map(({ id, text, additional }) => (
                <FormItem key={id}>
                    <Radio
                        checked={id === selectedId}
                        onChange={handleChange}
                        value={id}
                        wrapperProps={{ 'data-qa': 'price-popup-item' }}
                        data-qa="price-popup-item__input"
                        labelProps={{ 'data-qa': 'price-popup-item__text' }}
                    >
                        <RegionItemLabel isBackofficeRegion={additional?.visible === false} text={text} />
                    </Radio>
                </FormItem>
            ))}
        </>
    );
};

export default memo(translation(RegionsList));
